import { infoscreenLayoutView } from '../../../Types/AuthServer';
import { combineConsecutiveItems } from './combineConsecutiveItems';

interface Item {
    itemId: string;
    slotId: string;
}

// Function to transform and combine data
export function processData(data: infoscreenLayoutView | undefined): (Item & { count: number })[] {
    const items: Item[] = [];
    const itemCountMap: Record<string, number> = {}; // To keep track of item counts for slotIds

    if (!data) {
        return [];
    }

    data.itemsRow1.forEach((itemId, index) => {
        const slotId = (index + 1).toString(); // Generate slotId based on index
        itemCountMap[itemId] = (itemCountMap[itemId] ?? 0) + 1;

        items.push({ itemId, slotId });
    });

    data.itemsRow2.forEach((itemId) => {
        const slotId = (items.length + 1).toString(); // Generate slotId based on the current length of items
        itemCountMap[itemId] = (itemCountMap[itemId] ?? 0) + 1;

        items.push({ itemId, slotId });
    });

    return combineConsecutiveItems(items);
}
